import React from "react";

import MainContent from "./MainContent";

export default function App() {
  return <MainContent />;
}
